





































import Vue from 'vue';
import { BAlert } from 'bootstrap-vue';

import { mapActions } from 'vuex';
import { ModalSize } from '@/components/zen_modal/types';
import GenericCard from './GenericCard.vue';

export default Vue.extend({
  name: 'ExportConfirmation',
  components: {
    BAlert,
    GenericCard,
  },
  props: {
    objectType: {
      type: String,
      required: true,
    },
    rawObjectCount: {
      type: String,
      default: '',
    },
    selectedObjectsIds: {
      type: String, // Comma separated integers
      default: '',
    },
    exportQuery: {
      type: String,
      required: true,
    },
    actionUrl: {
      type: String,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
  },
  computed: {
    // TODO get rid of insideSPA
    insideSPA(): boolean {
      return !!this.$router;
    },
    objectCount(): number {
      return this.rawObjectCount.length ? Number(this.rawObjectCount) : this.selectedObjectsIds.split(',').length;
    },
    tooManyObjects(): boolean {
      return this.objectType === 'Revision' && this.objectCount > 10000;
    },
  },
  created() {
    if (this.insideSPA) {
      this.changeModalSize(ModalSize.Small);
    }
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      confirmModal: 'modals/confirm',
    }),
    confirmExport() {
      if (this.insideSPA) {
        const stripHtmlInExport = this.$refs.form.stripHtmlInExport.checked;
        this.confirmModal({ stripHtmlInExport: stripHtmlInExport });
      } else {
        const form = this.$refs.form;
        form.submit();
        this.$emit('close');
      }
    },
  },
});
